import React, {Component} from "react";

export default class Separator extends Component {

    render() {
        return (
            <div style={{
                flexGrow: 1
            }}/>
        );
    }
}